// 查询字符串参数的函数：
function getQueryStringArgs() {
  var qs = location.search.length > 0 ? location.search.substring(1) : ''
  var args = {}
  var items = qs.length ? qs.split('&') : []
  var item = null
  var name = null
  var value = null
  var i = 0
  var len = items.length
  for (; i < len; i++) {
    item = items[i].split('=')
    name = decodeURIComponent(item[0])
    value = decodeURIComponent(item[1])
    if (name.length) {
      args[name] = value
    }
  }
  return args
}
/**
 * @created on 2017/10/27
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// import { getRunTime } from '../../../../public-resource/libs/utils/index'

function getRunTime(str) {
  let result
  let _href = window.location.href.split('.')[0]

  _href.replace(/-(qc\d?|box\d?)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }

  return result
}
// 判断环境
let M_HOST = getRunTime('//m.xinli001.com')
let MXY_HOST = getRunTime('//m-xy.xinli001.com')
let STATIC_HOST = getRunTime('//static.xinli001.com')
let COLLEGE_HOST = getRunTime('//api-college.xinli001.com')
let KC_HOST = getRunTime('//kc.xinli001.com')

// function getRunningEnv() {
//   let env = location.host.split('.')[0].match(/(qc|box)\d?/g)
//   env = !!env ? (env.length > 0 ? '-' + env[0] : '') : ''
//   return `//m${env}.xinli001.com`
// }

// let m_Origin = getRunningEnv()
const GET_PARAMS = getQueryStringArgs()
let tokenParams = ''
if (GET_PARAMS.token) {
  tokenParams = '&token=' + GET_PARAMS.token
}
module.exports = {
  GET_PARAMS: GET_PARAMS,
  tokenParams: tokenParams,
  mHost: M_HOST,
  collegeHost: COLLEGE_HOST,
  mxyHost: MXY_HOST,
  staticHost: STATIC_HOST,
  // mOrigin: m_Origin,
  share: ``,
  wxJSSDK: ``,
  like: `${M_HOST}/lesson/comment/zan`,
  login: `${M_HOST}/account/login`,
  getComment: `${M_HOST}/lesson/rate-list`,
  lessonIndex: `${getRunTime(
    window.location.href.indexOf('xinli001.cc') !== -1
      ? '//m.xinli001.cc'
      : '//m.xinli001.com'
  )}/lesson`,
  // lessonpro: `${getRunTime('//static.xinli001.com')}/msite/index.html#/teacher?type=pro`,
  // 新的咨询师课首页
  lessonpro: `${getRunTime('//m.xinli001.com')}/lesson/proIndex?lessonType=pro`,
  getWXShareConfig: `${M_HOST}/wx/get-wx-package.json`,
  getCoupon: `${M_HOST}/lesson/getLessonCoupons`,
  receiveCoupon: `${location.origin}/lesson/getOneCoupon`, // 需要去到当前域名下的用户信息，不能写死使用m.xinli001.com
  getPeriodList: `${M_HOST}/lesson/getPeriodList`, // ?lesson_id=141&flag=1
  getCertOrNot: `${COLLEGE_HOST}/campContent/getCertOrNot`,
  lessonJoinGroup: `${getRunTime(
    '//kc.xinli001.com'
  )}/lingxikc/api/mstation/lessonJoinGroup`,
  getUserHeader: `${M_HOST}/ajax/get-user-header`,
  getPageData: `${KC_HOST}/lingxikc/api/activity/getPageData`,
  // 判断是否打卡，lessonId，keshiId，keshiType
  periodClock: `${KC_HOST}/lingxikc/lesson/periodClock`,
  // 获取收货地址
  getAddress: `${KC_HOST}/lingxikc/lesson/getAddress`,
  getCouponBusinessData: `${COLLEGE_HOST}/coupon/businessData`
}



// WEBPACK FOOTER //
// ./src/pages/lesson/detail/components/apis.js